import { WebViewerInstance } from '@pdftron/webviewer';
import { MutableRefObject } from 'react';

export type OnCloseClick = EmptyArgsVoidFunc;
export type IsVisible = boolean;

// Use enums to support granularity of read/write permission
export enum FileReadWriteState {
  Edit = 'EDIT',
  ReadOnly = 'READONLY',
}

/**
 * Represents a release, it's corresponding file Url, and the state of editing of the file
 */
export interface FileInformation {
  fileUrl: string | Blob;
  id: string;
  readWriteState: FileReadWriteState;
}

export interface Props {
  fileInformation: FileInformation[];
  handleFileChange?: (index: number) => void;
  fileId?: string;
  isVisible: IsVisible;
  onCloseClick: OnCloseClick;
  usePrivateViewer?: boolean;
  onUpdateDocument?: (file: Blob, url: string) => void;
}

export interface MultipleButtonsProp {
  handleNextDocumentClick: () => void;
  handlePreviousDocumentClick: () => void;
  previousDocumentButtonEnabled: boolean;
  nextDocumentButtonEnabled: boolean;
}

export type WebViewerInstanceExtended = WebViewerInstance & {
  loadDocument: EmptyArgsVoidFunc;
};

export type HandleClose = EmptyArgsVoidFunc;

export interface CloseConfig {
  onClick: HandleClose;
  isOutsideModal: boolean;
}

export type HandleSetRef = (ref: WebViewerInstanceExtended) => void;

export type PdfTronRef = MutableRefObject<Nullable<WebViewerInstanceExtended>>;
